import { CompanyAPI } from '@api';

const generateAntt = (params) => CompanyAPI.generateAntt(params)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { generateAntt };
